import { isRSAA, RSAA } from 'redux-api-middleware';
import {
	SUBMIT_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
	SUBMIT_BATCH_REQUEST,
} from '../../states/api/fasterPaymentActions';
import { SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST } from '../../states/api/chapsActions';
import {
	SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
} from '../../states/api/bacsActions';
import { SUBMIT_IFT_EDIT_PAYMENT_REQUEST, SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST } from '../../states/ift/actions';

import { biocatchFetchScoreCall } from '../../utils/biocatchUtils';

const whitelistActions = [
	SUBMIT_BATCH_REQUEST,
	SUBMIT_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
	SUBMIT_IFT_EDIT_PAYMENT_REQUEST,
	SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST,
];

const getSingularPaymentDetails = ([{ fromAccount, toAccount, amount, currencyCode }]) => ({
	fromAccountId: fromAccount,
	toAccountId: toAccount,
	amount,
	currencyCode,
});

const createBiocatchMiddleware =
	(getClientContext, getToken, getBankId, getApiBaseUrl, getApiBaseUrlPaas, getPaymentsForBiocatch) =>
	(store) =>
	(next) =>
	(action) => {
		if (isRSAA(action)) {
			const actionType = action[RSAA].types[0];

			if (whitelistActions.includes(actionType)) {
				const state = store.getState();
				const clientContext = getClientContext(state);
				const bankId = getBankId(state);
				const apiBaseUrl = getApiBaseUrl(state);
				const apiBaseUrlPaas = getApiBaseUrlPaas(state);
				const accessToken = getToken(state);
				const actionPayments = getPaymentsForBiocatch(state, actionType);

				const shouldIncludePaymentDetails =
					![SUBMIT_BATCH_REQUEST, SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST].includes(actionType) &&
					actionPayments.length === 1;

				biocatchFetchScoreCall({
					accessToken,
					activityType: 'PERSON_PAYMENT',
					apiBaseUrl,
					apiBaseUrlPaas,
					bankId,
					clientContext,
					scoreContext: 'PAYMENT',
					...(shouldIncludePaymentDetails && { paymentDetails: getSingularPaymentDetails(actionPayments) }),
				});
			}
		}
		return next(action);
	};

export default createBiocatchMiddleware;
